export const INDIA_DATA =[
    {
        "id": 4021,
        "name": "Maharashtra",
        "cities": [
            "Mumbai",
            "Pune",
            "Nagpur",
            "Thane",
            "Nashik",
            "Kalyan",
            "Vasai-Virar",
            "Aurangabad",
            "Navi Mumbai",
            "Solapur",
            "Mira-Bhayandar",
            "Bhiwandi",
            "Amravati",
            "Nanded",
            "Kolhapur",
            "Akola",
            "Sangli",
            "Jalgaon",
            "Latur",
            "Dhule",
            "Ahmednagar",
            "Chandrapur",
            "Parbhani",
            "Ichalkaranji",
            "Jalna",
            "Ambarnath",
            "Bhusawal",
            "Panvel",
            "Badlapur",
            "Beed",
            "Gondia",
            "Satara",
            "Barshi",
            "Yavatmal",
            "Achalpur",
            "Osmanabad",
            "Nandurbar",
            "Wardha",
            "Udgir",
            "Hingoli",
            "Malegaon",
            "Kamptee",
            "Ratnagiri",
            "Washim",
            "Amalner",
            "Faizpur",
            "Ozar",
            "Manmad",
            "Sillod",
            "Mukhed",
            "Malkapur",
            "Warora",
            "Shirpur-Warwade",
            "Wani",
            "Nandura",
            "Tasgaon",
            "Pathri",
            "Uran",
            "Deolali",
            "Phaltan",
            "Dharangaon",
            "Talode",
            "Shrirampur",
            "Sinnar",
            "Nevasa",
            "Dombivli",
            "Karad",
            "Palghar",
            "Roha",
            "Shirdi",
            "Khopoli",
            "Alibag",
            "Pen",
            "Mahad",
            "Boisar",
            "Kankavli",
            "Sawantwadi",
            "Kudal",
            "Dodamarg",
            "Vengurla",
            "Devgad",
            "Sindhudurg",
            "Ratnagiri",
            "Chiplun",
            "Guhagar",
            "Rajapur",
            "Lanja",
            "Mandangad",
            "Khed",
            "Dapoli",
            "Patan",
            "Shirgaon",
            "Mulshi",
            "Velhe",
            "Bhor",
            "Haveli",
            "Shirur",
            "Ambegaon",
            "Junnar",
            "Maval",
            "Khed",
            "Pimpri-Chinchwad",
            "Kondhwa",
            "Hadapsar",
            "Kharadi",
            "Baner",
            "Wakad",
            "Akurdi",
            "Nigdi",
            "Viman Nagar",
            "Kothrud",
            "Yerwada"
        ]
    },
    {
        "id": 4008,
        "name": "Gujarat",
        "cities": [
            "Ahmedabad",
            "Surat",
            "Vadodara",
            "Rajkot",
            "Bhavnagar",
            "Jamnagar",
            "Gandhinagar",
            "Junagadh",
            "Anand",
            "Nadiad",
            "Morbi",
            "Mehsana",
            "Surendranagar",
            "Bharuch",
            "Vapi",
            "Navsari",
            "Valsad",
            "Gandhidham",
            "Bhuj",
            "Porbandar",
            "Veraval",
            "Amreli",
            "Palanpur",
            "Patan",
            "Modasa",
            "Godhra",
            "Dahod",
            "Himmatnagar",
            "Botad",
            "Deesa",
            "Visnagar",
            "Kalol",
            "Karjan",
            "Umbergaon",
            "Sanand",
            "Dholka",
            "Vyara",
            "Mandvi",
            "Dwarka",
            "Kodinar",
            "Una",
            "Keshod",
            "Jetpur",
            "Gondal",
            "Mangrol",
            "Chhota Udaipur",
            "Khambhat",
            "Halol",
            "Bodeli"
        ]
    },
    {
        "id": 4039,
        "name": "Rajasthan",
        "cities": [
            "Jaipur",
            "Udaipur",
            "Jodhpur",
            "Kota",
            "Bikaner",
            "Ajmer",
            "Alwar",
            "Bharatpur",
            "Sikar",
            "Pali",
            "Neem Ka Thana",
            "Sri Ganganagar",
            "Hanumangarh",
            "Churu",
            "Jhunjhunu",
            "Barmer",
            "Jaisalmer",
            "Sawai Madhopur",
            "Dholpur",
            "Bundi",
            "Tonk",
            "Nagaur",
            "Rajsamand",
            "Banswara",
            "Dungarpur",
            "Karauli",
            "Pratapgarh",
            "Bhilwara",
            "Beawar",
            "Jhalawar",
            "Gangapur City"
        ]
    },
    {
        "id": 4049,
        "name": "Uttar Pradesh",
        "cities": [
            "Lucknow",
            "Kanpur",
            "Agra",
            "Varanasi",
            "Prayagraj",
            "Ghaziabad",
            "Noida",
            "Meerut",
            "Bareilly",
            "Aligarh",
            "Moradabad",
            "Saharanpur",
            "Gorakhpur",
            "Jhansi",
            "Firozabad",
            "Ayodhya",
            "Mathura",
            "Muzaffarnagar",
            "Shahjahanpur",
            "Rampur",
            "Budaun",
            "Hapur",
            "Etawah",
            "Sitapur",
            "Unnao",
            "Etah",
            "Lakhimpur Kheri",
            "Banda",
            "Farrukhabad",
            "Bulandshahr",
            "Gonda",
            "Sultanpur",
            "Amroha",
            "Hardoi",
            "Ballia",
            "Jaunpur",
            "Azamgarh",
            "Basti",
            "Mau",
            "Mirzapur",
            "Sonbhadra",
            "Chitrakoot"
        ]
    },
    {
        "id": 4031,
        "name": "Madhya Pradesh",
        "cities": [
            "Bhopal",
            "Indore",
            "Gwalior",
            "Jabalpur",
            "Ujjain",
            "Sagar",
            "Satna",
            "Rewa",
            "Ratlam",
            "Dewas",
            "Chhindwara",
            "Morena",
            "Shivpuri",
            "Vidisha",
            "Khargone",
            "Neemuch",
            "Mandsaur",
            "Hoshangabad",
            "Sehore",
            "Itarsi",
            "Betul",
            "Burhanpur",
            "Khandwa",
            "Damoh",
            "Panna",
            "Chhatarpur",
            "Seoni",
            "Mandla",
            "Shahdol",
            "Anuppur",
            "Singrauli"
        ]
    },
    {
        "id": 4024,
        "name": "Bihar",
        "cities": [
            "Patna",
            "Gaya",
            "Bhagalpur",
            "Muzaffarpur",
            "Darbhanga",
            "Purnia",
            "Arrah",
            "Begusarai",
            "Katihar",
            "Munger",
            "Chhapra",
            "Danapur",
            "Saharsa",
            "Hajipur",
            "Bihar Sharif",
            "Nalanda",
            "Sitamarhi",
            "Siwan",
            "Motihari",
            "Nawada",
            "Kishanganj",
            "Bettiah",
            "Jamalpur",
            "Araria",
            "Supaul",
            "Madhepura",
            "Buxar",
            "Sheohar",
            "Jehanabad",
            "Lakhisarai",
            "Sheikhpura"
        ]
    },
    {
        "id": 4030,
        "name": "Jharkhand",
        "cities": [
            "Ranchi",
            "Jamshedpur",
            "Dhanbad",
            "Bokaro Steel City",
            "Hazaribagh",
            "Deoghar",
            "Giridih",
            "Ramgarh",
            "Medininagar",
            "Chakradharpur",
            "Phusro",
            "Gumla",
            "Chaibasa",
            "Koderma",
            "Latehar",
            "Simdega",
            "Lohardaga",
            "Godda",
            "Sahebganj",
            "Dumka",
            "Pakur"
        ]
    },
    {
        "id": 4017,
        "name": "Chhattisgarh",
        "cities": [
            "Raipur",
            "Bhilai",
            "Durg",
            "Bilaspur",
            "Korba",
            "Rajnandgaon",
            "Jagdalpur",
            "Raigarh",
            "Ambikapur",
            "Mahasamund",
            "Dhamtari",
            "Kanker",
            "Kawardha",
            "Jashpur",
            "Surajpur",
            "Balrampur",
            "Balod",
            "Bemetara",
            "Gariaband",
            "Sukma",
            "Bijapur",
            "Narayanpur"
        ]
    },
    {
        "id": 4042,
        "name": "Punjab",
        "cities": [
            "Ludhiana",
            "Amritsar",
            "Jalandhar",
            "Patiala",
            "Bathinda",
            "Mohali",
            "Pathankot",
            "Hoshiarpur",
            "Moga",
            "Firozpur",
            "Sangrur",
            "Barnala",
            "Phagwara",
            "Kapurthala",
            "Abohar",
            "Khanna",
            "Malerkotla",
            "Muktsar",
            "Ropar",
            "Fatehgarh Sahib"
        ]
    },
    {
        "id": 4027,
        "name": "Haryana",
        "cities": [
            "Gurugram",
            "Faridabad",
            "Panipat",
            "Ambala",
            "Yamunanagar",
            "Hisar",
            "Karnal",
            "Rohtak",
            "Sonipat",
            "Rewari",
            "Bahadurgarh",
            "Sirsa",
            "Jind",
            "Kaithal",
            "Panchkula",
            "Bhiwani",
            "Kurukshetra",
            "Palwal",
            "Mahendragarh",
            "Fatehabad",
            "Charkhi Dadri"
        ]
    },
    {
        "id": 4028,
        "name": "Himachal Pradesh",
        "cities": [
            "Shimla",
            "Mandi",
            "Solan",
            "Kangra",
            "Dharamshala",
            "Bilaspur",
            "Hamirpur",
            "Kullu",
            "Chamba",
            "Nahan",
            "Una",
            "Sundernagar",
            "Palampur",
            "Baddi",
            "Parwanoo",
            "Paonta Sahib",
            "Kinnaur",
            "Lahaul and Spiti"
        ]
    },
    {
        "id": 4048,
        "name": "Uttarakhand",
        "cities": [
            "Dehradun",
            "Haridwar",
            "Rishikesh",
            "Haldwani",
            "Rudrapur",
            "Kashipur",
            "Roorkee",
            "Nainital",
            "Almora",
            "Pithoragarh",
            "Bageshwar",
            "Chamoli",
            "Uttarkashi",
            "Tehri",
            "Srinagar",
            "Kotdwar",
            "Mussoorie"
        ]
    },
    {
        "id": 4029,
        "name": "Kerala",
        "cities": [
            "Thiruvananthapuram",
            "Kochi",
            "Kozhikode",
            "Thrissur",
            "Alappuzha",
            "Palakkad",
            "Malappuram",
            "Kannur",
            "Kottayam",
            "Kollam",
            "Pathanamthitta",
            "Idukki",
            "Ernakulam",
            "Vatakara",
            "Chalakudy",
            "Kalpetta"
        ]
    },
    {
        "id": 4016,
        "name": "Karnataka",
        "cities": [
            "Bengaluru",
            "Mysuru",
            "Mangaluru",
            "Hubballi",
            "Belagavi",
            "Kalaburagi",
            "Davanagere",
            "Ballari",
            "Tumakuru",
            "Shivamogga",
            "Udupi",
            "Raichur",
            "Hassan",
            "Bidar",
            "Hospet",
            "Bagalkot",
            "Gadag",
            "Chitradurga",
            "Ramanagara"
        ]
    },
    {
        "id": 4044,
        "name": "Tamil Nadu",
        "cities": [
            "Chennai",
            "Coimbatore",
            "Madurai",
            "Tiruchirappalli",
            "Tiruppur",
            "Salem",
            "Erode",
            "Vellore",
            "Tirunelveli",
            "Thoothukudi",
            "Nagercoil",
            "Karur",
            "Dindigul",
            "Cuddalore",
            "Kanchipuram",
            "Rajapalayam",
            "Sivakasi",
            "Hosur",
            "Kumbakonam",
            "Neyveli",
            "Ambur",
            "Krishnagiri",
            "Dharmapuri",
            "Pudukkottai",
            "Nagapattinam",
            "Thanjavur",
            "Ariyalur",
            "Perambalur"
        ]
    },
    {
        "id": 4045,
        "name": "Telangana",
        "cities": [
            "Hyderabad",
            "Warangal",
            "Nizamabad",
            "Khammam",
            "Karimnagar",
            "Ramagundam",
            "Mahbubnagar",
            "Nalgonda",
            "Adilabad",
            "Suryapet",
            "Jagitial",
            "Mancherial",
            "Siddipet",
            "Kamareddy",
            "Wanaparthy",
            "Vikarabad",
            "Kothagudem"
        ]
    },
    {
        "id": 4013,
        "name": "Andhra Pradesh",
        "cities": [
            "Visakhapatnam",
            "Vijayawada",
            "Guntur",
            "Nellore",
            "Kurnool",
            "Rajahmundry",
            "Tirupati",
            "Kadapa",
            "Kakinada",
            "Anantapur",
            "Ongole",
            "Eluru",
            "Machilipatnam",
            "Chittoor",
            "Srikakulam",
            "Vizianagaram",
            "Amaravati"
        ]
    },
    {
        "id": 4025,
        "name": "Goa",
        "cities": [
            "Panaji",
            "Margao",
            "Vasco da Gama",
            "Mapusa",
            "Ponda",
            "Bicholim",
            "Canacona",
            "Curchorem",
            "Quepem",
            "Sanguem"
        ]
    },
    {
        "id": 4036,
        "name": "Odisha",
        "cities": [
            "Bhubaneswar",
            "Cuttack",
            "Rourkela",
            "Berhampur",
            "Sambalpur",
            "Balasore",
            "Bhadrak",
            "Baripada",
            "Jharsuguda",
            "Jeypore",
            "Bargarh",
            "Paradip",
            "Kendrapara",
            "Kendujhar",
            "Koraput",
            "Sundargarh",
            "Nabarangpur"
        ]
    },
    {
        "id": 4050,
        "name": "West Bengal",
        "cities": [
            "Kolkata",
            "Howrah",
            "Durgapur",
            "Asansol",
            "Siliguri",
            "Bardhaman",
            "Malda",
            "Kharagpur",
            "Haldia",
            "Jalpaiguri",
            "Balurghat",
            "Cooch Behar",
            "Krishnanagar",
            "Chandannagar",
            "Bankura",
            "Purulia",
            "Medinipur"
        ]
    },
    {
        "id": 4014,
        "name": "Assam",
        "cities": [
            "Guwahati",
            "Silchar",
            "Dibrugarh",
            "Jorhat",
            "Nagaon",
            "Tinsukia",
            "Tezpur",
            "Bongaigaon",
            "Sivasagar",
            "Karimganj",
            "Barpeta",
            "Dhubri",
            "Golaghat",
            "Lakhimpur",
            "Hojai",
            "Kokrajhar"
        ]
    },
    {
        "id": 4015,
        "name": "Arunachal Pradesh",
        "cities": [
            "Itanagar",
            "Naharlagun",
            "Tawang",
            "Ziro",
            "Bomdila",
            "Pasighat",
            "Aalo",
            "Tezu",
            "Roing",
            "Namsai",
            "Seppa"
        ]
    },
    {
        "id": 4033,
        "name": "Meghalaya",
        "cities": [
            "Shillong",
            "Tura",
            "Jowai",
            "Nongpoh",
            "Baghmara",
            "Williamnagar",
            "Mairang",
            "Resubelpara"
        ]
    },
    {
        "id": 4032,
        "name": "Manipur",
        "cities": [
            "Imphal",
            "Thoubal",
            "Bishnupur",
            "Ukhrul",
            "Churachandpur",
            "Senapati",
            "Chandel",
            "Tamenglong"
        ]
    },
    {
        "id": 4035,
        "name": "Nagaland",
        "cities": [
            "Kohima",
            "Dimapur",
            "Mokokchung",
            "Tuensang",
            "Wokha",
            "Zunheboto",
            "Mon",
            "Phek",
            "Kiphire",
            "Longleng"
        ]
    },
    {
        "id": 4047,
        "name": "Tripura",
        "cities": [
            "Agartala",
            "Udaipur",
            "Dharmanagar",
            "Kailasahar",
            "Belonia",
            "Khowai",
            "Ambassa",
            "Teliamura"
        ]
    },
    {
        "id": 4034,
        "name": "Mizoram",
        "cities": [
            "Aizawl",
            "Lunglei",
            "Saiha",
            "Champhai",
            "Kolasib",
            "Serchhip",
            "Mamit",
            "Lawngtlai"
        ]
    },
    {
        "id": 4040,
        "name": "Sikkim",
        "cities": [
            "Gangtok",
            "Namchi",
            "Geyzing",
            "Singtam",
            "Jorethang",
            "Mangan",
            "Ravangla"
        ]
    },
    {
        "id": 4072,
        "name": "Delhi",
        "cities": [
            "New Delhi",
            "North Delhi",
            "South Delhi",
            "East Delhi",
            "West Delhi",
            "Central Delhi",
            "Rohini",
            "Dwarka",
            "Janakpuri",
            "Lajpat Nagar",
            "Karol Bagh",
            "Saket",
            "Greater Kailash",
            "Vasant Kunj",
            "Okhla",
            "Tilak Nagar",
            "Punjabi Bagh",
            "Pitampura",
            "Shahdara",
            "Kalkaji",
            "Connaught Place"
        ]
    },
    {
        "id": 4073,
        "name": "Jammu and Kashmir",
        "cities": [
            "Srinagar",
            "Jammu",
            "Udhampur",
            "Anantnag",
            "Baramulla",
            "Kupwara",
            "Sopore",
            "Pulwama",
            "Kathua",
            "Doda",
            "Rajouri",
            "Poonch",
            "Ganderbal",
            "Bandipora"
        ]
    },
    {
        "id": 4074,
        "name": "Ladakh",
        "cities": [
            "Leh",
            "Kargil",
            "Nubra",
            "Zanskar",
            "Dras",
            "Diskit",
            "Sankoo"
        ]
    },
    {
        "id": 4075,
        "name": "Chandigarh",
        "cities": [
            "Chandigarh",
            "Manimajra",
            "Daria",
            "Sarangpur",
            "Raipur Khurd"
        ]
    },
    {
        "id": 4076,
        "name": "Puducherry",
        "cities": [
            "Puducherry",
            "Karaikal",
            "Mahe",
            "Yanam"
        ]
    },
    {
        "id": 4077,
        "name": "Andaman and Nicobar Islands",
        "cities": [
            "Port Blair",
            "Havelock Island",
            "Neil Island",
            "Diglipur",
            "Mayabunder",
            "Rangat",
            "Car Nicobar",
            "Little Andaman"
        ]
    },
    {
        "id": 4078,
        "name": "Lakshadweep",
        "cities": [
            "Kavaratti",
            "Agatti",
            "Andrott",
            "Minicoy",
            "Kalpeni",
            "Kadmath",
            "Bitra",
            "Chetlat"
        ]
    },
    {
        "id": 4079,
        "name": "Dadra and Nagar Haveli and Daman and Diu",
        "cities": [
            "Silvassa",
            "Daman",
            "Diu",
            "Amli",
            "Naroli",
            "Samarvarni",
            "Kadaiya",
            "Marwad"
        ]
    }
]